let nonHuman = ['Cancel - Duplicate', 'cancel NSA', 'Cancel Whatsapp', 'Cancel reject previous order'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
let Human = ['Cancel - CIM', 'Cancel - Price', "Cancel - Didn't need the order", 'Cancel - Others', 'Cancel ID', 'Cancel wrong number', 'cancel wrong person', "Cancel - Didn't Request", 'Cancel Delivery Fees', 'Cancel - Corona (COVID-19)', "Cancel don't have Card", 'Payment Order'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
let noAnswer = ['1st NA', '2nd NA', '3rd NA', 'Cancel - No Answer', 'call back', 'NEW', 'NEED CHECK', 'Call back After 11:00AM'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
let confirmed = ['Confirmed', 'Dispatch', 'NEW Confirm', 'Paid', 'Cancel Combine', 'pending payment'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))

let noSource = ['logstic', 'telemarketing', 'telemarkitig', 'c.care']

module.exports = {
  nonHuman,
  Human,
  noAnswer,
  confirmed
}